import { SyncStatus } from 'shared/domain/entitySyncStatus/syncStatus';
import { assignRemoteId } from 'serviceWorker/db/directories/directories';

type AddRemoteIdToDirectory = (localId: number, remoteId: string) => Promise<number>;

export const addRemoteIdToDirectory: AddRemoteIdToDirectory =
  function _addRemoteIdToDirectory(localId, remoteId) {
    return assignRemoteId(localId, remoteId, { syncStatus: SyncStatus.SUCCESS });
  };
